import React from 'react'

import { Form, Row, Col, Button } from '_zari/core'

import * as CentroCostoService from 'services/centrosCosto.service'

const FiltroCosto = ({ idCentroCostoNivel2, setIdCentroCostoNivel2, clickBuscar, ocultarTabla }) => {
  const [centrosNvlUno, setCentrosNvlUno] = React.useState([])
  const [centrosNvlDos, setCentrosNvlDos] = React.useState([])

  const [idCentroCostoNivel1, setIdCentroCostoNivel1] = React.useState('')

  React.useEffect(() => {
    CentroCostoService.obtenerxNivel(1).then(({ data }) => {
      setCentrosNvlUno(data)
    })
  }, [])

  const onChangeCentroNvlUno = React.useCallback(
    _id => {
      setIdCentroCostoNivel1(_id)

      ocultarTabla()

      setIdCentroCostoNivel2('')
      setCentrosNvlDos([])

      if (_id !== '') {
        CentroCostoService.obtenerNodosHijosxIdAsSelect(_id).then(({ data }) => {
          setCentrosNvlDos(data)
        })
      }
    },
    [setIdCentroCostoNivel2, ocultarTabla]
  )

  return (
    <Row>
      <Col md={12}>
        <Form.Group>
          <Form.Label text='Centro Nivel 1' md={4} alignRightAt='md' />
          <Col md={8}>
            <Form.Select
              id='centroCostoNvl1Select'
              name='centroNivelUno'
              value={idCentroCostoNivel1}
              onChange={e => onChangeCentroNvlUno(e.target.value)}
            >
              <option value=''>Seleccionar</option>
              {centrosNvlUno.map(x => (
                <option key={x._id} value={x._id}>{`${x.codigo} - ${x.descripcion}`}</option>
              ))}
            </Form.Select>
          </Col>
        </Form.Group>
        <Form.Group>
          <Form.Label text='Centro Nivel 2' md={4} alignRightAt='md' />
          <Col md={8}>
            <Form.Select
              id='centroCostoNvl2Select'
              name='centroNivelDos'
              value={idCentroCostoNivel2}
              onChange={e => {
                setIdCentroCostoNivel2(e.target.value)
                ocultarTabla()
              }}
            >
              <option value=''>Seleccionar</option>
              {centrosNvlDos.map(x => (
                <option key={x._id} value={x._id}>{`${x.codigo} - ${x.descripcion}`}</option>
              ))}
            </Form.Select>
          </Col>
        </Form.Group>
        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickBuscar}>Buscar</Button>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default React.memo(FiltroCosto)
